/**
* In this file contains the chart UI design and logic
**/
import { Modal,Button } from 'react-bootstrap';
import ApiService from './../../services/ApiService';
import { useEffect,useState } from 'react';
import { convertUTCtoDateAndTime } from './../../services/UtilsService';
import Pagination from './../../shared/components/Pagination';
import {Chart as ChartJS,CategoryScale,LinearScale,PointElement,LineElement,Title,Tooltip,Legend} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { postAnalytics } from './../../services/ReusabilityService';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function ChartModal(props) {
	
	// Intial state declaration
	const [request,setRequest]=useState({page:0,limit:10,id:props.data.member,category:props.data.chartName});
	const [chartData,setChartData]=useState([]);
	const [graphData,setGraphData] = useState({hidden:true});
	const [count,setCount]=useState(0);
	
	//components  Intial function
	useEffect(()=>{
		(async()=>{
		 try {
			var response;
			if(props.data.chartName === 'Weight' || props.data.chartName === 'Height'){
				response = await ApiService.listMemberMeasurement(request);
			}else{
				response = await ApiService.listMemberVitals(request);
			}
			if(response.status===200){
				setChartData(response.data.items);
				setCount(response.data.count);
				sessionStorage.setItem('screenStartTime', new Date());
				var items = response.data.items;
				// Sort items array in ascending order based on createdAt
				items.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
				var labels = await items.map((item)=> convertUTCtoDateAndTime(item.createdAt));
				
				var label = props.data.chartName;
				var values ;
				
				switch (label) {
				  case 'Weight':
					values = items.map((item) => item.weight);
					break;
				  case 'Height':
					values = items.map((item) => item.height);
					break;
				  default:
					values = items.map((item) => item.value);
				}
				
				//To initialize the chart color
				var graphValues = [
					{
						name: "Weight",
						borderColor: 'rgb(0 196 239 / 75%)',
						backgroundColor: 'rgb(0 196 239 / 25%)',
					},
					{
					   name: "Height",
					   borderColor:'rgb(255 111 154 / 75%)',
					   backgroundColor: 'rgb(255 111 154 / 25%)',
					},
					{
					   name: 3,
					   borderColor:'rgb(76 175 80 / 75%)',
					   backgroundColor: 'rgb(76 175 80 / 25%)',
					},
					{
					   name: 1,
					   borderColor:'rgb(156 39 176 / 75%)',
					   backgroundColor: 'rgb(156 39 176 / 25%)',
					},
					{
					   name: 2,
					   borderColor:'rgb(255 193 7 / 75%)',
					   backgroundColor: 'rgb(255 193 7 / 25%)',
					},
				];
				
				var filterColor = await graphValues.filter((graph) => graph.name === label);
				
				setGraphData({ labels: labels, label: label, values: values, borderColor: filterColor[0]?.borderColor, backgroundColor: filterColor[0]?.backgroundColor });
			}
		 } catch (error) {
			console.error(error);
		 }
		})();
		
		//To post the Analytics data
		return async()=>{
			var reqData={};
			reqData.parent = props.data.parent;
			reqData.member = props.data.member;
			reqData.module = 'vitals';
			reqData.type = props.data.type;
			postAnalytics(reqData);
		}
		
	},[request,props]);
	
	//To find length of values
	const totalValues = graphData &&  graphData.values && graphData.values.length;
	
	//To change the chartContainerBody width 
	const chartContainerBodyWidth = totalValues > 10 ? `${totalValues * 50}px` : '100%';
	
	//To define the chart options 
	const options = {
	  responsive: true,
	  maintainAspectRatio: false,
	  plugins: {
		  tooltip: {
			callbacks: {
				label: (context:any) =>{
				const data = context.chart.data;
				switch (data.datasets[context.datasetIndex].label) {
					case 3:
						return 'Temperature: '+context.formattedValue;
					case 1:
						return 'Heart Rate: '+context.formattedValue;
					case 2:
						return 'Blood Glucose: '+context.formattedValue;
					default:
						return data.datasets[context.datasetIndex].label+': '+context.formattedValue;
					}
				}
			}
		  },
		legend: {
		  position: 'top',
		  display:false,
		},
		title: {
		  display: true,
		},
	  },
	};
	
	//To define the chart data
	const data = {
	  labels:graphData.labels,
	  datasets: [
		{
		  label: graphData.label ,
		  data: graphData.values,
		  borderWidth: 1,
		  pointRadius:6,
	      pointHoverRadius: 10,
		  borderColor: graphData?.borderColor,
		  backgroundColor: graphData?.backgroundColor,
		  hidden: graphData.hidden
		}
	  ],
	};
	
	//To find the last Chart value
	function getLastChartText(label, chartData) {
		switch (label) {
		case 'Weight':
			return 'Last Weight: ' + (chartData.length > 0 ? chartData[chartData.length - 1].weight + ' Kg' : '');
		case 'Height':
			return 'Last Height: ' + (chartData.length > 0 ? chartData[chartData.length - 1].height + ' cm' : '');
		case 3:
			return 'Last Temperature: ' + (chartData.length > 0 ? chartData[chartData.length - 1].value + ' °C' : '');
		case 1:
			return 'Last Heart Rate: ' + (chartData.length > 0 ? chartData[chartData.length - 1].value + ' bpm' : '');
		case 2:
			return 'Last Blood Glucose: ' + (chartData.length > 0 ? chartData[chartData.length - 1].value + ' mg/dL' : '');
		default:
			return '';
		}
	}
	
	/**
	* To handle pagination event
	* @data get the user selected page number
	**/
	const handlePaginate=(data)=>{ 
		setRequest(req=>({...req,page:data}));
	};
	
	/**
	* To handle the chartLimit change
	* @e we get the event details from the change action
	**/
	const changeChartLimit = (e) => {
		e.preventDefault();
		setRequest(req=>({...req,[e.target.name]: e.target.value,page:0}));
	}
	
	/**
	* To hide or unhide graph points 
	* @e we get the event details from the click action
	**/
	const handleHide = (e) => {
		e.preventDefault();
		setGraphData({...graphData,hidden:!graphData.hidden});
	}
	
	return (
		<Modal 
		show={props.data.chart} 
		onHide={props.handleClose}  
		backdrop="static"
		keyboard={false}
		size="md"
		aria-labelledby="contained-modal-title-vcenter"
		centered
		>
	    <Modal.Header closeButton>
		<Modal.Title><h5 className="modal-title" id="appointmentsModalLabel"><span className="member-name text-capitalize">{props.data.name}'s {props.data.chartName===1 ? "Heart Rate":props.data.chartName===2 ? "Blood Glucose" :props.data.chartName===3 ? "Temperature":props.data.chartName}</span> History</h5></Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<div className="chart">
			{/*Chat Header*/}
				<div className = "row">
					<div className= "col-12">
					{chartData.length > 0 &&
						<div className="float-end me-3">
							<select className="form-select fw-bold" style={{fontSize:'12px',cursor:'pointer'}} value={request.limit} name="limit" onChange={changeChartLimit}>
								<option value="10">10</option>
								<option value="25">25</option>
								<option value="50">50</option>
						   </select>
						</div>
					}
					</div>
				</div>
				{/*End Chat Header*/}
				<div className="row">
					<div className="col-12">
					  {chartData.length > 0 &&
					    <div>
						<p style={{textAlign:'center',fontSize:'13px',fontWeight:'600'}}> {getLastChartText(graphData.label, chartData)} </p>
						<div className="d-flex justify-content-center">
						<button className="mx-2" onClick={handleHide} style={{border:`1px solid ${graphData.borderColor}`,backgroundColor:graphData.backgroundColor,height:'13px',width:'41px'}} ></button>
							<p style={{fontSize:'13px',margin:'-2px'}}>{props.data.chartName===1 ? "Heart Rate":props.data.chartName===2 ? "Blood Glucose" :props.data.chartName===3 ? "Temperature":props.data.chartName}</p>
						</div>
					   </div>
					  }
					</div>
				</div>
				<div className = "row">
					<div className="col-12">
						{chartData.length > 0 ? (
							<div className="chartContainer">
								<div className="chartContainerBody" style={{ width: chartContainerBodyWidth }}>
									{/*Import the Line Modal*/}
									<Line options={options} data={data} /> 
								</div>
							</div> 
						):(
							<div className="text-center fs-5">No record found</div>
						)}
					</div>
				</div>
				{/*Pagination*/}
				{chartData.length !==0 &&
				<div className="row my-3">
					<div className="col-xxl-12 d-flex justify-content-center">
						 <Pagination page={request.page} handlePaginate={handlePaginate} total={count} limit={request.limit} />
					</div>
				</div>
				}
				{/*End Pagination*/}
			</div>
		</Modal.Body>
		
		{/*Footer*/}
		<Modal.Footer>
			<Button variant="secondary" className="btn btn-sm btn-tmPink" onClick={props.handleClose}>
				Close
			</Button>
		</Modal.Footer>
		</Modal>
	);
}

export default ChartModal;